/* Options:
Date: 2020-07-30 14:35:39
Version: 5.80
Tip: To override a DTO option, remove "//" prefix before updating
BaseUrl: https://localhost:5001

//GlobalNamespace: 
//AddServiceStackTypes: True
//AddResponseStatus: False
//AddImplicitVersion: 
//AddDescriptionAsComments: True
//IncludeTypes: 
//ExcludeTypes: 
//DefaultImports: 
*/


export interface IReturn<T>
{
    createResponse(): T;
}

export interface IReturnVoid
{
    createResponse(): void;
}

export interface IHasSessionId
{
    sessionId: string;
}

export interface IHasBearerToken
{
    bearerToken: string;
}

export interface IGet
{
}

export interface IPost
{
}

export interface IPut
{
}

export interface IDelete
{
}

// @DataContract
export class ExchangeRate
{
    // @DataMember(Order=1)
    public code: string;

    // @DataMember(Order=2)
    public rate: number;

    public constructor(init?: Partial<ExchangeRate>) { (Object as any).assign(this, init); }
}

export interface ILocalizable
{
    culture: string;
}

// @DataContract
export class CountryInfo
{
    // @DataMember(Order=1)
    public name: string;

    // @DataMember(Order=2)
    public iso: string;

    // @DataMember(Order=3)
    public iso3: string;

    // @DataMember(Order=4)
    public isoNumeric: number;

    // @DataMember(Order=5)
    public fips: string;

    // @DataMember(Order=6)
    public capital: string;

    // @DataMember(Order=7)
    public area: number;

    // @DataMember(Order=8)
    public continent: string;

    // @DataMember(Order=9)
    public topLevelDomain: string;

    // @DataMember(Order=10)
    public currencyCode: string;

    // @DataMember(Order=11)
    public currencyName: string;

    // @DataMember(Order=12)
    public phonePrefix: string;

    // @DataMember(Order=13)
    public postCodeFormat: string;

    // @DataMember(Order=14)
    public postCodeRegex: string;

    // @DataMember(Order=15)
    public languages: string[];

    public constructor(init?: Partial<CountryInfo>) { (Object as any).assign(this, init); }
}

// @DataContract
export class State
{
    // @DataMember(Order=1)
    public name: string;

    // @DataMember(Order=2)
    public code: string;

    // @DataMember(Order=3)
    public postCode: string;

    // @DataMember(Order=4)
    public provinces: Province[];

    public constructor(init?: Partial<State>) { (Object as any).assign(this, init); }
}

// @DataContract
export class StateList
{
    // @DataMember(Order=1)
    public name: string;

    // @DataMember(Order=2)
    public code: string;

    // @DataMember(Order=3)
    public postCode: string;

    public constructor(init?: Partial<StateList>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ProvinceList
{
    // @DataMember(Order=1)
    public name: string;

    // @DataMember(Order=2)
    public code: string;

    // @DataMember(Order=3)
    public postCode: string;

    // @DataMember(Order=4)
    public stateName: string;

    public constructor(init?: Partial<ProvinceList>) { (Object as any).assign(this, init); }
}

export enum LookupType
{
    Country = 'Country',
    Province = 'Province',
    Salutation = 'Salutation',
    SpokenLanguage = 'SpokenLanguage',
    CvSources = 'CvSources',
    Brand = 'Brand',
    State = 'State',
    EmploymentType = 'EmploymentType',
}

// @DataContract
export class Option
{
    // @DataMember(Order=1)
    public label: string;

    // @DataMember(Order=2)
    public value: string;

    // @DataMember(Order=3)
    public isDefault: boolean;

    public constructor(init?: Partial<Option>) { (Object as any).assign(this, init); }
}

// @DataContract
export class DateInferred implements IInferred
{
    // @DataMember(Order=0)
    public value: string;

    // @DataMember(Order=1)
    public inferred: boolean;

    public constructor(init?: Partial<DateInferred>) { (Object as any).assign(this, init); }
}

// @DataContract
export class StringInferred implements IInferred
{
    // @DataMember(Order=0)
    public value: string;

    // @DataMember(Order=1)
    public inferred: boolean;

    public constructor(init?: Partial<StringInferred>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PersonInfo
{
    // @DataMember(Order=0)
    public forename: string;

    // @DataMember(Order=2)
    public surname: string;

    // @DataMember(Order=1)
    public middleName: string;

    // @DataMember(Order=3)
    public dateOfBirth: DateInferred;

    // @DataMember(Order=4)
    public nationality: StringInferred;

    // @DataMember(Order=5)
    public birthplace: string;

    // @DataMember(Order=6)
    public gender: StringInferred;

    // @DataMember(Order=7)
    public maritalStatus: StringInferred;

    // @DataMember(Order=8)
    public hasDrivingLicense: boolean;

    // @DataMember(Order=9)
    public fullName: string;

    public constructor(init?: Partial<PersonInfo>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ContactInfo
{
    // @DataMember(Order=0)
    public telephone: string;

    // @DataMember(Order=1)
    public mobile: string;

    // @DataMember(Order=2)
    public email: string;

    // @DataMember(Order=3)
    public linkedIn: string;

    // @DataMember(Order=4)
    public webAddress: string;

    // @DataMember(Order=5)
    public addressLines: string;

    // @DataMember(Order=6)
    public municipality: string;

    // @DataMember(Order=7)
    public region: string;

    // @DataMember(Order=8)
    public postalCode: string;

    // @DataMember(Order=9)
    public country: string;

    public constructor(init?: Partial<ContactInfo>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SkillsInfo
{
    // @DataMember(Order=0)
    public taxonomy: SkillTaxonomy[];

    public constructor(init?: Partial<SkillsInfo>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ResumeDocumentInfo
{
    // @DataMember(Order=0)
    public resumeLanguage: string;

    // @DataMember(Order=1)
    public coverLetter: string;

    // @DataMember(Order=2)
    public resumeCulture: string;

    // @DataMember(Order=3)
    public parsingErrors: ParsingIssue[];

    // @DataMember(Order=4)
    public suggestedImprovements: ParsingIssue[];

    public constructor(init?: Partial<ResumeDocumentInfo>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ExperienceInfo
{
    // @DataMember(Order=0)
    public personalSummary: string;

    // @DataMember(Order=1)
    public inferredExperienceSummary: string;

    // @DataMember(Order=2)
    public monthsOfWorkExperience: number;

    // @DataMember(Order=3)
    public averageMonthsPerEmployer: number;

    // @DataMember(Order=4)
    public executiveType: string;

    // @DataMember(Order=5)
    public managementStory: string;

    // @DataMember(Order=6)
    public currentManagementLevel: string;

    // @DataMember(Order=7)
    public managementScore: number;

    // @DataMember(Order=8)
    public monthsOfManagementExperience: number;

    // @DataMember(Order=9)
    public fullTimeDirectHirePredictiveIndex: number;

    public constructor(init?: Partial<ExperienceInfo>) { (Object as any).assign(this, init); }
}

// @DataContract
export class Salary
{
    // @DataMember(Order=1)
    public currencyIso: string;

    // @DataMember(Order=2)
    public amount: number;

    public constructor(init?: Partial<Salary>) { (Object as any).assign(this, init); }
}

// @DataContract
export class HiringInfo
{
    // @DataMember(Order=0)
    public currentLocation: string;

    // @DataMember(Order=1)
    public preferredLocation: string;

    // @DataMember(Order=2)
    public availability: string;

    // @DataMember(Order=3)
    public willingToRelocate: string;

    // @DataMember(Order=4)
    public visaStatus: string;

    // @DataMember(Order=4)
    public requiredSalary: Salary;

    // @DataMember(Order=5)
    public currentSalary: Salary;

    public constructor(init?: Partial<HiringInfo>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EducationInfo
{
    // @DataMember(Order=0)
    public hasUnderGraduateDegree: boolean;

    // @DataMember(Order=1)
    public hasPostGraduateDegree: boolean;

    // @DataMember(Order=2)
    public hasDoctorate: boolean;

    // @DataMember(Order=3)
    public qualifications: Qualification[];

    public constructor(init?: Partial<EducationInfo>) { (Object as any).assign(this, init); }
}

// @DataContract
export class Language
{
    // @DataMember(Order=0)
    public languageCode: string;

    // @DataMember(Order=1)
    public canRead: boolean;

    // @DataMember(Order=2)
    public canWrite: boolean;

    // @DataMember(Order=3)
    public canSpeak: boolean;

    // @DataMember(Order=4)
    public notes: string;

    // @DataMember(Order=5)
    public isMotherTongue: boolean;

    public constructor(init?: Partial<Language>) { (Object as any).assign(this, init); }
}

// @DataContract
export class LanguageInfo
{
    // @DataMember(Order=0)
    public defaultLanguage: Language;

    // @DataMember(Order=1)
    public languages: Language[];

    public constructor(init?: Partial<LanguageInfo>) { (Object as any).assign(this, init); }
}

// @DataContract
export class Position
{
    // @DataMember(Order=0)
    public name: string;

    // @DataMember(Order=1)
    public type: string;

    // @DataMember(Order=2)
    public level: string;

    // @DataMember(Order=3)
    public employerName: string;

    // @DataMember(Order=4)
    public startDate: string;

    // @DataMember(Order=5)
    public endDate: string;

    // @DataMember(Order=6)
    public description: string;

    // @DataMember(Order=7)
    public current: boolean;

    // @DataMember(Order=8)
    public locations: LocationInfo[];

    // @DataMember(Order=10)
    public employeesSupervised: number;

    // @DataMember(Order=11)
    public isContractRole: boolean;

    // @DataMember(Order=12)
    public skillCategories: string[];

    public constructor(init?: Partial<Position>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EmploymentInfo
{
    // @DataMember(Order=0)
    public currentJobObjective: string;

    // @DataMember(Order=1)
    public currentPosition: Position;

    // @DataMember(Order=2)
    public positions: Position[];

    public constructor(init?: Partial<EmploymentInfo>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CertificationInfo
{
    // @DataMember(Order=0)
    public certificates: Certificate[];

    public constructor(init?: Partial<CertificationInfo>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PublicationInfo
{
    // @DataMember(Order=0)
    public publications: Publication[];

    public constructor(init?: Partial<PublicationInfo>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PublicSpeakingInfo
{
    // @DataMember(Order=0)
    public events: PublicSpeakingEvent[];

    public constructor(init?: Partial<PublicSpeakingInfo>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PatentInfo
{
    // @DataMember(Order=0)
    public patents: Patent[];

    public constructor(init?: Partial<PatentInfo>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TrainingInfo
{
    // @DataMember(Order=0)
    public training: Training[];

    public constructor(init?: Partial<TrainingInfo>) { (Object as any).assign(this, init); }
}

// @DataContract
export class Coordinates
{
    // @DataMember(Order=0)
    public latitude: number;

    // @DataMember(Order=1)
    public longitude: number;

    public constructor(init?: Partial<Coordinates>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ViewPort
{
    // @DataMember(Order=0)
    public northEast: Coordinates;

    // @DataMember(Order=1)
    public southWest: Coordinates;

    public constructor(init?: Partial<ViewPort>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GeoLocation
{
    // @DataMember(Order=0)
    public source: string;

    // @DataMember(Order=1)
    public location: Coordinates;

    // @DataMember(Order=2)
    public viewport: ViewPort;

    // @DataMember(Order=3)
    public placeId: string;

    // @DataMember(Order=4)
    public locationType: string;

    // @DataMember(Order=5)
    public formattedAddress: string;

    public constructor(init?: Partial<GeoLocation>) { (Object as any).assign(this, init); }
}

// @DataContract
export class NormalisedResumeSection
{
    // @DataMember(Order=0)
    public sectionType: string;

    // @DataMember(Order=1)
    public title: string;

    // @DataMember(Order=2)
    public text: string;

    public constructor(init?: Partial<NormalisedResumeSection>) { (Object as any).assign(this, init); }
}

// @DataContract
export class NormalisedResume
{
    // @DataMember
    public sections: NormalisedResumeSection[];

    public constructor(init?: Partial<NormalisedResume>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SThreeResume
{
    // @DataMember(Order=0)
    public person: PersonInfo;

    // @DataMember(Order=1)
    public contact: ContactInfo;

    // @DataMember(Order=2)
    public skills: SkillsInfo;

    // @DataMember(Order=3)
    public resumeDocumentInfo: ResumeDocumentInfo;

    // @DataMember(Order=4)
    public experience: ExperienceInfo;

    // @DataMember(Order=5)
    public hiring: HiringInfo;

    // @DataMember(Order=6)
    public education: EducationInfo;

    // @DataMember(Order=7)
    public language: LanguageInfo;

    // @DataMember(Order=8)
    public employment: EmploymentInfo;

    // @DataMember(Order=9)
    public certifications: CertificationInfo;

    // @DataMember(Order=10)
    public publications: PublicationInfo;

    // @DataMember(Order=11)
    public publicSpeaking: PublicSpeakingInfo;

    // @DataMember(Order=12)
    public patents: PatentInfo;

    // @DataMember(Order=13)
    public training: TrainingInfo;

    // @DataMember(Order=14)
    public geoLocation: GeoLocation;

    // @DataMember(Order=15)
    public normalisedResume: NormalisedResume;

    public constructor(init?: Partial<SThreeResume>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ParseResult
{
    // @DataMember(Order=0)
    public code: string;

    // @DataMember(Order=1)
    public message: string;

    // @DataMember(Order=2)
    public errors: boolean;

    // @DataMember(Order=3)
    public warnings: boolean;

    public constructor(init?: Partial<ParseResult>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SThreeCandidateResume
{
    // @DataMember(Order=0)
    public resume: SThreeResume;

    // @DataMember(Order=1)
    public resumeScrubbed: SThreeResume;

    // @DataMember(Order=2)
    public rawParsedDocument: string;

    // @DataMember(Order=3)
    public rawScrubbedParsedDocument: string;

    // @DataMember(Order=4)
    public textDocument: string;

    // @DataMember(Order=5)
    public textCode: ParseResult;

    // @DataMember(Order=6)
    public fileExtension: string;

    // @DataMember(Order=7)
    public fileType: string;

    // @DataMember(Order=8)
    public parseResult: ParseResult;

    // @DataMember(Order=9)
    public geocodeResult: ParseResult;

    // @DataMember(Order=10)
    public candidateImage: Uint8Array;

    // @DataMember(Order=11)
    public candidateImageExtension: string;

    // @DataMember(Order=12)
    public parserTimeInMilliseconds: number;

    // @DataMember(Order=13)
    public parserRawOutput: string;

    // @DataMember(Order=14)
    public parserSource: string;

    // @DataMember(Order=15)
    public parserVersion: string;

    // @DataMember(Order=16)
    public parserConfig: string;

    public constructor(init?: Partial<SThreeCandidateResume>) { (Object as any).assign(this, init); }
}

// @DataContract
export class DuplicateCandidate
{
    // @DataMember(Order=1)
    public id: string;

    // @DataMember(Order=2)
    public brandedPublicId: string;

    // @DataMember(Order=3)
    public email: string;

    // @DataMember(Order=4)
    public forename: string;

    // @DataMember(Order=5)
    public forenameMatchScore: number;

    // @DataMember(Order=6)
    public surname: string;

    // @DataMember(Order=7)
    public surnameMatchScore: number;

    // @DataMember(Order=8)
    public city: string;

    // @DataMember(Order=9)
    public country: string;

    // @DataMember(Order=10)
    public lastContactDate: string;

    // @DataMember(Order=11)
    public status: string;

    public constructor(init?: Partial<DuplicateCandidate>) { (Object as any).assign(this, init); }
}

export class SalesforcePickList
{
    public value: string;
    public active: boolean;
    public label: string;
    public defaultValue: boolean;
    public validFor: string;

    public constructor(init?: Partial<SalesforcePickList>) { (Object as any).assign(this, init); }
}

export class SalesforceField
{
    public length: number;
    public name: string;
    public type: string;
    public defaultValue: Object;
    public inlineHelpText: Object;
    public writeRequiresMasterRead: boolean;
    public precision: number;
    public unique: boolean;
    public controllerName: Object;
    public deprecatedAndHidden: boolean;
    public createable: boolean;
    public updateable: boolean;
    public externalId: boolean;
    public idLookup: boolean;
    public nameField: boolean;
    public sortable: boolean;
    public filterable: boolean;
    public restrictedPicklist: boolean;
    public caseSensitive: boolean;
    public relationshipName: string;
    public byteLength: number;
    public label: string;
    public calculated: boolean;
    public scale: number;
    public picklistValues: SalesforcePickList[];
    public autoNumber: boolean;
    public nillable: boolean;
    public displayLocationInDecimal: boolean;
    public cascadeDelete: boolean;
    public restrictedDelete: boolean;
    public calculatedFormula: Object;
    public defaultValueFormula: Object;
    public defaultedOnCreate: boolean;
    public digits: number;
    public groupable: boolean;
    public permissionable: boolean;
    public referenceTo: Object[];
    public relationshipOrder: Object;
    public soapType: string;
    public dependentPicklist: boolean;
    public namePointing: boolean;
    public custom: boolean;
    public htmlFormatted: boolean;

    public constructor(init?: Partial<SalesforceField>) { (Object as any).assign(this, init); }
}

export class SalesforceRecordTypeInfoLayoutUrl
{
    public layout: string;

    public constructor(init?: Partial<SalesforceRecordTypeInfoLayoutUrl>) { (Object as any).assign(this, init); }
}

export class SalesforceRecordTypeInfo
{
    public name: string;
    public recordTypeId: string;
    public available: boolean;
    public urls: SalesforceRecordTypeInfoLayoutUrl;
    public defaultRecordTypeMapping: boolean;

    public constructor(init?: Partial<SalesforceRecordTypeInfo>) { (Object as any).assign(this, init); }
}

export class SalesforceChildRelationship
{
    public field: string;
    public deprecatedAndHidden: boolean;
    public relationshipName: string;
    public cascadeDelete: boolean;
    public restrictedDelete: boolean;
    public childSObject: string;

    public constructor(init?: Partial<SalesforceChildRelationship>) { (Object as any).assign(this, init); }
}

export class SalesforceObjectUrls
{
    public uiEditTemplate: string;
    public sobject: string;
    public quickActions: string;
    public uiDetailTemplate: string;
    public describe: string;
    public rowTemplate: string;
    public layouts: string;
    public compactLayouts: string;
    public uiNewRecord: string;

    public constructor(init?: Partial<SalesforceObjectUrls>) { (Object as any).assign(this, init); }
}

export class SalesforceObject
{
    public name: string;
    public fields: SalesforceField[];
    public customSetting: boolean;
    public undeletable: boolean;
    public mergeable: boolean;
    public replicateable: boolean;
    public triggerable: boolean;
    public feedEnabled: boolean;
    public retrieveable: boolean;
    public searchLayoutable: boolean;
    public lookupLayoutable: Object;
    public listViewable: Object;
    public deprecatedAndHidden: boolean;
    public recordTypeInfos: SalesforceRecordTypeInfo[];
    public createable: boolean;
    public deletable: boolean;
    public updateable: boolean;
    public queryable: boolean;
    public layoutable: boolean;
    public activateable: boolean;
    public labelPlural: string;
    public keyPrefix: string;
    public custom: boolean;
    public compactLayoutable: boolean;
    public searchable: boolean;
    public label: string;
    public childRelationships: SalesforceChildRelationship[];
    public urls: SalesforceObjectUrls;

    public constructor(init?: Partial<SalesforceObject>) { (Object as any).assign(this, init); }
}

export class ParsedCVRecord
{
    public id: string;
    public parseSuccess: boolean;
    public parseWarnings: boolean;
    public parser: string;
    public parsedAt: string;
    // @StringLength(100)
    public filePath: string;

    public fileLength: number;
    // @StringLength(10)
    public fileExtension: string;

    // @StringLength(100)
    public fileType: string;

    // @StringLength(50)
    public parserSource: string;

    // @StringLength(10)
    public parserVersion: string;

    // @StringLength(50)
    public parserResultCode: string;

    public parserRawOutput: string;
    public parserConfig: string;
    public parserTimeToParse: number;
    public parseErrors: ParseIssue[];
    public resumeIssues: ParseIssue[];

    public constructor(init?: Partial<ParsedCVRecord>) { (Object as any).assign(this, init); }
}

export class CvUploadRecord implements ISoftDelete
{
    public id: number;
    // @StringLength(20)
    public uploadedById: string;

    // @StringLength(5)
    public fileExt: string;

    // @StringLength(255)
    public blobStoreIdentifier: string;

    public uploadedAt: string;
    public existingCandidateExtId: number;
    // @StringLength(20)
    public forCandidateId: string;

    // @StringLength(20)
    public forJobId: string;

    // @StringLength(50)
    public source: string;

    // @StringLength(2)
    public brand: string;

    // @StringLength(10)
    public candidateSalutation: string;

    // @StringLength(50)
    public candidateForename: string;

    // @StringLength(50)
    public candidateSurname: string;

    public candidateDateOfBirth: string;
    // @StringLength(50)
    public candidateCvLanguage: string;

    // @StringLength(10)
    public candidateCvLanguageCode: string;

    // @StringLength(3)
    public candidateContactLanguageCode: string;

    // @StringLength(255)
    public candidateEmail: string;

    // @StringLength(50)
    public candidateTelephone: string;

    // @StringLength(50)
    public candidateMobile: string;

    // @StringLength(100)
    public candidateStreet: string;

    // @StringLength(50)
    public candidateCity: string;

    // @StringLength(50)
    public candidateProvince: string;

    // @StringLength(20)
    public candidatePostalCode: string;

    // @StringLength(100)
    public candidateCurrentJobTitle: string;

    // @StringLength(100)
    public candidateCountryCode: string;

    // @StringLength(200)
    public candidateRegionCode: string;

    // @References(typeof(ParsedCVRecord))
    // @StringLength(32)
    public parsedCvRecordId: string;

    public parsedCvRecord: ParsedCVRecord;
    public isDeleted: boolean;
    public committed: boolean;
    // @StringLength(50)
    public candidateCountry: string;

    // @StringLength(50)
    public employmentType: string;

    public constructor(init?: Partial<CvUploadRecord>) { (Object as any).assign(this, init); }
}

// @DataContract
export class StagedString
{
    // @DataMember(Order=1)
    public value: string;

    // @DataMember(Order=2)
    public cv: string;

    // @DataMember(Order=3)
    public sf: string;

    public constructor(init?: Partial<StagedString>) { (Object as any).assign(this, init); }
}

// @DataContract
export class StagedDateTime
{
    // @DataMember(Order=1)
    public value: string;

    // @DataMember(Order=2)
    public cv: string;

    // @DataMember(Order=3)
    public sf: string;

    public constructor(init?: Partial<StagedDateTime>) { (Object as any).assign(this, init); }
}

// @DataContract
export class StagedCandidate
{
    // @DataMember(Order=1)
    public id: number;

    // @DataMember(Order=2)
    public externalId: string;

    // @DataMember(Order=3)
    public brandedPublicId: string;

    // @DataMember(Order=4)
    public salutation: StagedString;

    // @DataMember(Order=5)
    public forename: StagedString;

    // @DataMember(Order=6)
    public surname: StagedString;

    // @DataMember(Order=7)
    public dateOfBirth: StagedDateTime;

    // @DataMember(Order=8)
    public lastContactDate: string;

    // @DataMember(Order=9)
    public language: StagedString;

    // @DataMember(Order=10)
    public jobTitle: StagedString;

    // @DataMember(Order=11)
    public employmentType: string;

    // @DataMember(Order=12)
    public street: StagedString;

    // @DataMember(Order=13)
    public city: StagedString;

    // @DataMember(Order=14)
    public province: StagedString;

    // @DataMember(Order=14)
    public state: StagedString;

    // @DataMember(Order=15)
    public country: StagedString;

    // @DataMember(Order=16)
    public postalCode: StagedString;

    // @DataMember(Order=17)
    public email: StagedString;

    // @DataMember(Order=18)
    public telephone: StagedString;

    // @DataMember(Order=19)
    public mobile: StagedString;

    // @DataMember(Order=20)
    public brand: string;

    // @DataMember(Order=21)
    public cvSource: string;

    // @DataMember(Order=22)
    public cvFileName: string;

    // @DataMember(Order=23)
    public cvDate: string;

    // @DataMember(Order=24)
    public status: string;

    // @DataMember(Order=25)
    public parsingIssues: ParsingIssue[];

    // @DataMember(Order=26)
    public uploadedAt: string;

    public constructor(init?: Partial<StagedCandidate>) { (Object as any).assign(this, init); }
}

export interface IPagedRequest
{
    skip: number;
    take: number;
}

// @DataContract
export class StagedCandidateListView
{
    // @DataMember(Order=1)
    public id: number;

    // @DataMember(Order=2)
    public firstName: string;

    // @DataMember(Order=3)
    public lastName: string;

    // @DataMember(Order=4)
    public uploadedAt: string;

    // @DataMember(Order=5)
    public forJobId: string;

    // @DataMember(Order=6)
    public isValid: boolean;

    public constructor(init?: Partial<StagedCandidateListView>) { (Object as any).assign(this, init); }
}

export interface IPagedResult
{
    skip: number;
    take: number;
    hasPrev: boolean;
    hasNext: boolean;
}

// @DataContract
export class ResponseError
{
    // @DataMember(Order=1, EmitDefaultValue=false)
    public errorCode: string;

    // @DataMember(Order=2, EmitDefaultValue=false)
    public fieldName: string;

    // @DataMember(Order=3, EmitDefaultValue=false)
    public message: string;

    // @DataMember(Order=4, EmitDefaultValue=false)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<ResponseError>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ResponseStatus
{
    // @DataMember(Order=1)
    public errorCode: string;

    // @DataMember(Order=2)
    public message: string;

    // @DataMember(Order=3)
    public stackTrace: string;

    // @DataMember(Order=4)
    public errors: ResponseError[];

    // @DataMember(Order=5)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<ResponseStatus>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UserApiKey
{
    // @DataMember(Order=1)
    public key: string;

    // @DataMember(Order=2)
    public keyType: string;

    // @DataMember(Order=3)
    public expiryDate: string;

    // @DataMember(Order=4)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<UserApiKey>) { (Object as any).assign(this, init); }
}

// @DataContract
export class Province
{
    // @DataMember(Order=1)
    public name: string;

    // @DataMember(Order=2)
    public code: string;

    // @DataMember(Order=3)
    public postCode: string;

    // @DataMember(Order=4)
    public communities: Community[];

    public constructor(init?: Partial<Province>) { (Object as any).assign(this, init); }
}

export interface ISoftDelete
{
    isDeleted: boolean;
}

export enum ParseIssueLevel
{
    Severe = 'Severe',
    Warning = 'Warning',
    Information = 'Information',
}

// @DataContract
export class ParsingIssue
{
    // @DataMember(Order=1)
    public level: ParseIssueLevel;

    // @DataMember(Order=2)
    public description: string;

    public constructor(init?: Partial<ParsingIssue>) { (Object as any).assign(this, init); }
}

// @DataContract
export class Location
{
    // @DataMember(Order=1)
    public latitude: number;

    // @DataMember(Order=2)
    public longitude: number;

    public constructor(init?: Partial<Location>) { (Object as any).assign(this, init); }
}

// @DataContract
export class Place
{
    // @DataMember(Order=1)
    public name: string;

    // @DataMember(Order=2)
    public postCode: string;

    // @DataMember(Order=3)
    public location: Location;

    public constructor(init?: Partial<Place>) { (Object as any).assign(this, init); }
}

// @DataContract
export class Community
{
    // @DataMember(Order=1)
    public name: string;

    // @DataMember(Order=2)
    public code: string;

    // @DataMember(Order=3)
    public postCode: string;

    // @DataMember(Order=4)
    public places: Place;

    public constructor(init?: Partial<Community>) { (Object as any).assign(this, init); }
}

export class ParseIssue
{
    public level: ParseIssueLevel;
    public description: string;

    public constructor(init?: Partial<ParseIssue>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SkillTaxonomy
{
    // @DataMember(Order=0)
    public name: string;

    // @DataMember(Order=1)
    public percentOfOverall: number;

    // @DataMember(Order=3)
    public subTaxonomies: SkillSubTaxonomy[];

    public constructor(init?: Partial<SkillTaxonomy>) { (Object as any).assign(this, init); }
}

// @DataContract
export class Qualification
{
    // @DataMember(Order=0)
    public name: string;

    // @DataMember(Order=1)
    public type: string;

    // @DataMember(Order=2)
    public date: string;

    // @DataMember(Order=3)
    public institute: string;

    // @DataMember(Order=4)
    public notes: string;

    public constructor(init?: Partial<Qualification>) { (Object as any).assign(this, init); }
}

// @DataContract
export class Certificate
{
    // @DataMember(Order=0)
    public name: string;

    // @DataMember(Order=1)
    public description: string;

    public constructor(init?: Partial<Certificate>) { (Object as any).assign(this, init); }
}

// @DataContract
export class Publication
{
    // @DataMember(Order=0)
    public title: string;

    // @DataMember(Order=1)
    public issue: string;

    // @DataMember(Order=2)
    public publicationDate: string;

    // @DataMember(Order=3)
    public journalOrSerialName: string;

    public constructor(init?: Partial<Publication>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PublicSpeakingEvent
{
    // @DataMember(Order=0)
    public name: string;

    // @DataMember(Order=1)
    public eventType: string;

    // @DataMember(Order=2)
    public description: string;

    public constructor(init?: Partial<PublicSpeakingEvent>) { (Object as any).assign(this, init); }
}

// @DataContract
export class Patent
{
    // @DataMember(Order=0)
    public title: string;

    // @DataMember(Order=1)
    public description: string;

    // @DataMember(Order=2)
    public inventors: string[];

    public constructor(init?: Partial<Patent>) { (Object as any).assign(this, init); }
}

// @DataContract
export class Training
{
    // @DataMember(Order=0)
    public id: string;

    // @DataMember(Order=1)
    public name: string;

    // @DataMember(Order=2)
    public description: string;

    public constructor(init?: Partial<Training>) { (Object as any).assign(this, init); }
}

export interface IInferred
{
    inferred?: boolean;
}

// @DataContract
export class SkillSubTaxonomy
{
    // @DataMember(Order=0)
    public name: string;

    // @DataMember(Order=1)
    public percentOfOverall: number;

    // @DataMember(Order=2)
    public percentOfParentTaxonomy: number;

    // @DataMember(Order=3)
    public sKills: Skill[];

    public constructor(init?: Partial<SkillSubTaxonomy>) { (Object as any).assign(this, init); }
}

// @DataContract
export class LocationInfo
{
    // @DataMember(Order=0)
    public countryCode: string;

    // @DataMember(Order=1)
    public region: string;

    // @DataMember(Order=2)
    public municipality: string;

    public constructor(init?: Partial<LocationInfo>) { (Object as any).assign(this, init); }
}

// @DataContract
export class Skill
{
    // @DataMember(Order=0)
    public name: string;

    // @DataMember(Order=1)
    public monthsOfExperience: number;

    // @DataMember(Order=2)
    public inferred: boolean;

    // @DataMember(Order=3)
    public lastUsed: string;

    // @DataMember(Order=4)
    public childSkills: Skill[];

    public constructor(init?: Partial<Skill>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetCurrenciesResponse
{

    public constructor(init?: Partial<GetCurrenciesResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetExchangeRatesResponse
{
    // @DataMember(Order=1)
    public base: string;

    // @DataMember(Order=2)
    public lastUpdated: string;

    // @DataMember(Order=3)
    public rates: ExchangeRate[];

    public constructor(init?: Partial<GetExchangeRatesResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetCountriesResponse
{
    // @DataMember(Order=1)
    public countries: CountryInfo[];

    public constructor(init?: Partial<GetCountriesResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetLocationResponse
{
    // @DataMember(Order=1)
    public states: State[];

    public constructor(init?: Partial<GetLocationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetCountryStatesResponse
{
    // @DataMember(Order=1)
    public states: StateList[];

    public constructor(init?: Partial<GetCountryStatesResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetCountryProvincesResponse
{
    // @DataMember(Order=1)
    public provinces: ProvinceList[];

    public constructor(init?: Partial<GetCountryProvincesResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetLanguagesResponse
{

    public constructor(init?: Partial<GetLanguagesResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetLookupResponse
{
    // @DataMember(Order=1)
    public options: Option[];

    public constructor(init?: Partial<GetLookupResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ParseCvResponse
{
    // @DataMember(Order=1)
    public parseId: string;

    // @DataMember(Order=1)
    public filePath: string;

    // @DataMember(Order=2)
    public candidateResume: SThreeCandidateResume;

    public constructor(init?: Partial<ParseCvResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetCandidateResumeResponse
{
    // @DataMember(Order=1)
    public candidateResume: SThreeCandidateResume;

    // @DataMember(Order=2)
    public sourceCvHash: string;

    public constructor(init?: Partial<GetCandidateResumeResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetSalesforceCandidateResponse
{
    // @DataMember(Order=1)
    public id: string;

    // @DataMember(Order=2)
    public brandedPublicId: string;

    // @DataMember(Order=3)
    public email: string;

    // @DataMember(Order=4)
    public forename: string;

    // @DataMember(Order=5)
    public surname: string;

    // @DataMember(Order=6)
    public jobTitle: string;

    // @DataMember(Order=7)
    public city: string;

    // @DataMember(Order=8)
    public country: string;

    // @DataMember(Order=9)
    public lastContactDate: string;

    // @DataMember(Order=10)
    public status: string;

    // @DataMember(Order=11)
    public brand: string;

    public constructor(init?: Partial<GetSalesforceCandidateResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetCandidateDuplicatesResponse
{
    // @DataMember(Order=1)
    public candidates: DuplicateCandidate[];

    // @DataMember(Order=2)
    public hasExactMatch: boolean;

    // @DataMember(Order=3)
    public noMatchesFound: boolean;

    public constructor(init?: Partial<GetCandidateDuplicatesResponse>) { (Object as any).assign(this, init); }
}

export class GetSalesforceObjectResponse
{
    public metadata: SalesforceObject;

    public constructor(init?: Partial<GetSalesforceObjectResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetSalesforceInfoResponse
{
    // @DataMember(Order=1)
    public instanceUrl: string;

    public constructor(init?: Partial<GetSalesforceInfoResponse>) { (Object as any).assign(this, init); }
}

export class IndexCandidateResponse
{

    public constructor(init?: Partial<IndexCandidateResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetStagedCandidateResponse
{
    // @DataMember(Order=1)
    public stagedCandidate: StagedCandidate;

    public constructor(init?: Partial<GetStagedCandidateResponse>) { (Object as any).assign(this, init); }
}

/**
* Returns a new staged candidate id
*/
// @Api(Description="Returns a new staged candidate id")
// @DataContract
export class CreateStagedCandidateResponse
{
    // @DataMember(Order=1)
    public id: number;

    public constructor(init?: Partial<CreateStagedCandidateResponse>) { (Object as any).assign(this, init); }
}

// @ApiResponse(Description="The staged candidate was successfully updated", StatusCode=200)
// @DataContract
export class UpdateStagedCandidateResponse
{
    // @DataMember(Order=1)
    public externalId: string;

    public constructor(init?: Partial<UpdateStagedCandidateResponse>) { (Object as any).assign(this, init); }
}

// @ApiResponse(Description="The candidate was successfully deleted", StatusCode=204)
// @DataContract
export class DeleteStagedCandidateResponse
{

    public constructor(init?: Partial<DeleteStagedCandidateResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetStagedCandidateCvResponse
{
    // @DataMember(Order=1)
    public normalisedCv: NormalisedResume;

    public constructor(init?: Partial<GetStagedCandidateCvResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetStagedCandidatesResponse implements IPagedResult
{
    // @DataMember(Order=1)
    public candidates: StagedCandidateListView[];

    // @DataMember(Order=2)
    public skip: number;

    // @DataMember(Order=3)
    public take: number;

    // @DataMember(Order=4)
    public hasNext: boolean;

    // @DataMember(Order=5)
    public hasPrev: boolean;

    public constructor(init?: Partial<GetStagedCandidatesResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AuthenticateResponse implements IHasSessionId, IHasBearerToken
{
    // @DataMember(Order=1)
    public userId: string;

    // @DataMember(Order=2)
    public sessionId: string;

    // @DataMember(Order=3)
    public userName: string;

    // @DataMember(Order=4)
    public displayName: string;

    // @DataMember(Order=5)
    public referrerUrl: string;

    // @DataMember(Order=6)
    public bearerToken: string;

    // @DataMember(Order=7)
    public refreshToken: string;

    // @DataMember(Order=8)
    public profileUrl: string;

    // @DataMember(Order=9)
    public roles: string[];

    // @DataMember(Order=10)
    public permissions: string[];

    // @DataMember(Order=11)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=12)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<AuthenticateResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetApiKeysResponse
{
    // @DataMember(Order=1)
    public results: UserApiKey[];

    // @DataMember(Order=2)
    public meta: { [index: string]: string; };

    // @DataMember(Order=3)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetApiKeysResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RegenerateApiKeysResponse
{
    // @DataMember(Order=1)
    public results: UserApiKey[];

    // @DataMember(Order=2)
    public meta: { [index: string]: string; };

    // @DataMember(Order=3)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<RegenerateApiKeysResponse>) { (Object as any).assign(this, init); }
}

/**
* Returns a list of currencies
*/
// @Route("/currencies", "GET")
// @Api(Description="Returns a list of currencies")
// @DataContract
export class GetCurrenciesRequest implements IReturn<GetCurrenciesResponse>
{

    public constructor(init?: Partial<GetCurrenciesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetCurrenciesResponse(); }
    public getTypeName() { return 'GetCurrenciesRequest'; }
}

/**
* Returns a list of currency approximate exchange rates, not suitable for financial transactions
*/
// @Route("/currencies/exchangerates/{Rate}", "GET")
// @Api(Description="Returns a list of currency approximate exchange rates, not suitable for financial transactions")
// @DataContract
export class GetExchangeRatesRequest implements IReturn<GetExchangeRatesResponse>
{
    /**
    * The base rate for each currency
    */
    // @DataMember(Order=1)
    // @ApiMember(Description="The base rate for each currency")
    public base: string;

    public constructor(init?: Partial<GetExchangeRatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetExchangeRatesResponse(); }
    public getTypeName() { return 'GetExchangeRatesRequest'; }
}

// @Route("/country", "GET")
// @Route("/country/code/{IsoCode}", "GET")
// @Route("/country/name/{Name}", "GET")
// @Route("/country/lang/{Language}", "GET")
// @Route("/country/continent/{Continent}", "GET")
// @Route("/country/currency/{CurrencyCode}", "GET")
// @DataContract
export class GetCountriesRequest implements IReturn<GetCountriesResponse>, IGet, ILocalizable
{
    /**
    * Match all or part of an iso 2 or 3 character code
    */
    // @DataMember(Order=1)
    // @ApiMember(Description="Match all or part of an iso 2 or 3 character code")
    public isoCode: string;

    /**
    * Match all or part of a country name
    */
    // @DataMember(Order=2)
    // @ApiMember(Description="Match all or part of a country name")
    public name: string;

    /**
    * Match all or part of a language code
    */
    // @DataMember(Order=3)
    // @ApiMember(Description="Match all or part of a language code")
    public language: string;

    /**
    * Match all or part of a continent code
    */
    // @DataMember(Order=4)
    // @ApiMember(Description="Match all or part of a continent code")
    public continent: string;

    /**
    * Match all or part of a currency code
    */
    // @DataMember(Order=5)
    // @ApiMember(Description="Match all or part of a currency code")
    public currencyCode: string;

    /**
    * Match all or part of a countries international dialling prefix
    */
    // @DataMember(Order=6)
    // @ApiMember(Description="Match all or part of a countries international dialling prefix")
    public phonePrefix: string;

    /**
    * Match all or part of a countries top level internet domain, e.g. .uk, .es, de 
    */
    // @DataMember(Order=7)
    // @ApiMember(Description="Match all or part of a countries top level internet domain, e.g. .uk, .es, de ")
    public domain: string;

    /**
    * Find countries that could match a specific zipcode/postalcode
    */
    // @DataMember(Order=8)
    // @ApiMember(Description="Find countries that could match a specific zipcode/postalcode")
    public zipcode: string;

    /**
    * Translates the country names to the specified culture code. Defaults to en-GB
    */
    // @DataMember(Order=9)
    // @ApiMember(Description="Translates the country names to the specified culture code. Defaults to en-GB")
    public culture: string;

    public constructor(init?: Partial<GetCountriesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetCountriesResponse(); }
    public getTypeName() { return 'GetCountriesRequest'; }
}

// @Route("/country/{CountryIso}/location/", "GET")
// @DataContract
export class GetLocationRequest implements IReturn<GetLocationResponse>, IGet
{
    /**
    * The country iso code
    */
    // @DataMember(Order=1)
    // @ApiMember(Description="The country iso code", IsRequired=true)
    public countryIso: string;

    // @DataMember(Order=2)
    public state: string;

    // @DataMember(Order=3)
    public province: string;

    public constructor(init?: Partial<GetLocationRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetLocationResponse(); }
    public getTypeName() { return 'GetLocationRequest'; }
}

// @Route("/country/{CountryIso}/states", "GET")
// @Route("/country/{CountryIso}/states/{State}", "GET")
// @DataContract
export class GetCountryStatesRequest implements IReturn<GetCountryStatesResponse>
{
    // @DataMember(Order=1)
    public countryIso: string;

    // @DataMember(Order=2)
    public state: string;

    public constructor(init?: Partial<GetCountryStatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetCountryStatesResponse(); }
    public getTypeName() { return 'GetCountryStatesRequest'; }
}

// @Route("/country/{CountryIso}/provinces", "GET")
// @Route("/country/{CountryIso}/provinces/{Province}", "GET")
// @Route("/country/{CountryIso}/{State}/{Province}", "GET")
// @DataContract
export class GetCountryProvincesRequest implements IReturn<GetCountryProvincesResponse>
{
    // @DataMember(Order=1)
    public countryIso: string;

    // @DataMember(Order=2)
    public state: string;

    // @DataMember(Order=3)
    public province: string;

    public constructor(init?: Partial<GetCountryProvincesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetCountryProvincesResponse(); }
    public getTypeName() { return 'GetCountryProvincesRequest'; }
}

// @DataContract
export class GetLanguagesRequest implements IReturn<GetLanguagesResponse>, IGet
{

    public constructor(init?: Partial<GetLanguagesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetLanguagesResponse(); }
    public getTypeName() { return 'GetLanguagesRequest'; }
}

/**
* Returns lookup lists
*/
// @Route("/lookup/{LookupType}", "GET")
// @Api(Description="Returns lookup lists")
// @DataContract
export class GetLookupRequest implements IReturn<GetLookupResponse>
{
    /**
    * the lookup list identifier
    */
    // @DataMember(Order=1)
    // @ApiMember(Description="the lookup list identifier", IsRequired=true)
    public lookupType: LookupType;

    /**
    * the lookup list parent identifier
    */
    // @DataMember(Order=2)
    // @ApiMember(Description="the lookup list parent identifier")
    public parentId: string;

    /**
    * the userId - used to filter some lists, deprecate once api calls are user-context specific
    */
    // @DataMember(Order=3)
    // @ApiMember(Description="the userId - used to filter some lists, deprecate once api calls are user-context specific")
    public userId: string;

    public constructor(init?: Partial<GetLookupRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetLookupResponse(); }
    public getTypeName() { return 'GetLookupRequest'; }
}

/**
* Parses a CV
*/
// @Route("/cv/parse", "POST")
// @Api(Description="Parses a CV")
// @DataContract
export class ParseCvRequest implements IReturn<ParseCvResponse>, IPost
{
    /**
    * The CV file content
    */
    // @DataMember(Order=1)
    // @ApiMember(Description="The CV file content", IsRequired=true)
    public fileBytes: Uint8Array;

    /**
    * The CV file extension
    */
    // @DataMember(Order=2)
    // @ApiMember(Description="The CV file extension", IsRequired=true)
    public fileExtension: string;

    public constructor(init?: Partial<ParseCvRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ParseCvResponse(); }
    public getTypeName() { return 'ParseCvRequest'; }
}

/**
* Gets a candidates resume data
*/
// @Route("/cv/data/{Hash}", "GET")
// @Api(Description="Gets a candidates resume data")
// @DataContract
export class GetCandidateResumeRequest implements IReturn<GetCandidateResumeResponse>, IGet
{
    /**
    * The candidate cv's unique file hash
    */
    // @DataMember(Order=1)
    // @ApiMember(Description="The candidate cv\'s unique file hash", IsRequired=true)
    public hash: string;

    public constructor(init?: Partial<GetCandidateResumeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetCandidateResumeResponse(); }
    public getTypeName() { return 'GetCandidateResumeRequest'; }
}

/**
* Gets a candidates cv file
*/
// @Route("/cv/file/{Hash}", "GET")
// @Api(Description="Gets a candidates cv file")
// @DataContract
export class GetCandidateResumeFileRequest implements IReturn<Uint8Array>, IGet
{
    /**
    * The file's unique hash
    */
    // @DataMember(Order=1)
    // @ApiMember(Description="The file\'s unique hash", IsRequired=true)
    public hash: string;

    /**
    * Optional override the default download filename
    */
    // @DataMember(Order=2)
    // @ApiMember(Description="Optional override the default download filename")
    public downloadAs: string;

    public constructor(init?: Partial<GetCandidateResumeFileRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new Uint8Array(0); }
    public getTypeName() { return 'GetCandidateResumeFileRequest'; }
}

/**
* Returns a candidate from Salesforce by Id
*/
// @Route("/candidate/external/salesforce/{SalesforceId}", "GET")
// @Api(Description="Returns a candidate from Salesforce by Id")
// @DataContract
export class GetSalesforceCandidateRequest implements IReturn<GetSalesforceCandidateResponse>, IGet
{
    /**
    * The salesforce candidate identifier
    */
    // @DataMember(Order=1)
    // @ApiMember(Description="The salesforce candidate identifier", IsRequired=true)
    public salesforceId: string;

    public constructor(init?: Partial<GetSalesforceCandidateRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetSalesforceCandidateResponse(); }
    public getTypeName() { return 'GetSalesforceCandidateRequest'; }
}

/**
* Looks for possible duplicate candidates in an external system
*/
// @Route("/candidate/duplicates/{CandidateId}", "GET")
// @Route("/candidate/duplicates", "GET")
// @Api(Description="Looks for possible duplicate candidates in an external system")
// @DataContract
export class GetCandidateDuplicatesRequest implements IReturn<GetCandidateDuplicatesResponse>, IGet
{
    /**
    * The id of the staged candidate to check, must be supplied if other details are not
    */
    // @DataMember(Order=1)
    // @ApiMember(Description="The id of the staged candidate to check, must be supplied if other details are not")
    public candidateId: number;

    /**
    * The brand to check for the duplicate candidate
    */
    // @DataMember(Order=2)
    // @ApiMember(Description="The brand to check for the duplicate candidate")
    public brand: string;

    /**
    * The email to check for the duplicate candidate
    */
    // @DataMember(Order=3)
    // @ApiMember(Description="The email to check for the duplicate candidate")
    public email: string;

    /**
    * The first name to check for the duplicate candidate
    */
    // @DataMember(Order=4)
    // @ApiMember(Description="The first name to check for the duplicate candidate")
    public firstName: string;

    /**
    * The last name to check for the duplicate candidate
    */
    // @DataMember(Order=5)
    // @ApiMember(Description="The last name to check for the duplicate candidate")
    public lastName: string;

    public constructor(init?: Partial<GetCandidateDuplicatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetCandidateDuplicatesResponse(); }
    public getTypeName() { return 'GetCandidateDuplicatesRequest'; }
}

export class GetSalesforceObjectRequest implements IReturn<GetSalesforceObjectResponse>, IGet
{
    public objectName: string;

    public constructor(init?: Partial<GetSalesforceObjectRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetSalesforceObjectResponse(); }
    public getTypeName() { return 'GetSalesforceObjectRequest'; }
}

/**
* Returns Salesforce instance information
*/
// @Route("/salesforce/info", "GET")
// @Api(Description="Returns Salesforce instance information")
// @DataContract
export class GetSalesforceInfoRequest implements IReturn<GetSalesforceInfoResponse>, IGet
{

    public constructor(init?: Partial<GetSalesforceInfoRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetSalesforceInfoResponse(); }
    public getTypeName() { return 'GetSalesforceInfoRequest'; }
}

export class IndexCandidateRequest implements IReturn<IndexCandidateResponse>, IPut
{
    public stagedCandidate: CvUploadRecord;

    public constructor(init?: Partial<IndexCandidateRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new IndexCandidateResponse(); }
    public getTypeName() { return 'IndexCandidateRequest'; }
}

/**
* Gets a staged candidate
*/
// @Route("/candidate/staged/id/{CandidateId}", "GET")
// @Route("/candidate/staged/id/{CandidateId}/ext/{ExternalId}", "GET")
// @Api(Description="Gets a staged candidate")
// @DataContract
export class GetStagedCandidateRequest implements IReturn<GetStagedCandidateResponse>, IGet
{
    /**
    * the staged candidate Id
    */
    // @DataMember(Order=1)
    // @ApiMember(Description="the staged candidate Id", IsRequired=true)
    public candidateId: number;

    /**
    * optional external id to overlay additional candidate information, used when switching associated external contact
    */
    // @DataMember(Order=2)
    // @ApiMember(Description="optional external id to overlay additional candidate information, used when switching associated external contact")
    public externalId: string;

    public constructor(init?: Partial<GetStagedCandidateRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetStagedCandidateResponse(); }
    public getTypeName() { return 'GetStagedCandidateRequest'; }
}

/**
* Creates a staged candidate
*/
// @Route("/candidate/staged/create", "PUT")
// @Api(Description="Creates a staged candidate")
// @DataContract
export class CreateStagedCandidateRequest implements IReturn<CreateStagedCandidateResponse>, IPut, IPost
{
    /**
    * The user id creating the staged candidate
    */
    // @DataMember(Order=1)
    // @ApiMember(Description="The user id creating the staged candidate", IsRequired=true)
    public uploadedById: string;

    /**
    * The external identifier for the candidate
    */
    // @DataMember(Order=2)
    // @ApiMember(Description="The external identifier for the candidate")
    public forCandidateId: string;

    /**
    * The source of the staged candidate
    */
    // @DataMember(Order=3)
    // @ApiMember(Description="The source of the staged candidate", IsRequired=true)
    public source: string;

    /**
    * The brand associated with the staged candidate
    */
    // @DataMember(Order=4)
    // @ApiMember(Description="The brand associated with the staged candidate", IsRequired=true)
    public brand: string;

    /**
    * The staged candidate cv file extension
    */
    // @DataMember(Order=5)
    // @ApiMember(Description="The staged candidate cv file extension", IsRequired=true)
    public fileExt: string;

    /**
    * The staged candidate's cv
    */
    // @DataMember(Order=6)
    // @ApiMember(Description="The staged candidate\'s cv", IsRequired=true)
    public fileContent: Uint8Array;

    /**
    * The job ad id associated with the staged candidate
    */
    // @DataMember(Order=7)
    // @ApiMember(Description="The job ad id associated with the staged candidate")
    public forJobId: string;

    public constructor(init?: Partial<CreateStagedCandidateRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new CreateStagedCandidateResponse(); }
    public getTypeName() { return 'CreateStagedCandidateRequest'; }
}

/**
* Updates a staged candidate's details
*/
// @Route("/candidate/staged/update", "POST")
// @Api(Description="Updates a staged candidate\'s details")
// @DataContract
export class UpdateStagedCandidateRequest implements IReturn<UpdateStagedCandidateResponse>, IPost
{
    /**
    * The identifier for the staged candidate
    */
    // @DataMember(Order=1)
    // @ApiMember(Description="The identifier for the staged candidate", IsRequired=true)
    public id: number;

    /**
    * The brand associated with the staged candidate
    */
    // @DataMember(Order=2)
    // @ApiMember(Description="The brand associated with the staged candidate", IsRequired=true)
    public brand: string;

    /**
    * The external candidate system identifier
    */
    // @DataMember(Order=3)
    // @ApiMember(Description="The external candidate system identifier", IsRequired=true)
    public externalId: string;

    /**
    * The candidate's salutation
    */
    // @DataMember(Order=4)
    // @ApiMember(Description="The candidate\'s salutation", IsRequired=true)
    public salutation: string;

    /**
    * The candidate's first name
    */
    // @DataMember(Order=5)
    // @ApiMember(Description="The candidate\'s first name", IsRequired=true)
    public forename: string;

    /**
    * The candidate's last name
    */
    // @DataMember(Order=6)
    // @ApiMember(Description="The candidate\'s last name", IsRequired=true)
    public surname: string;

    /**
    * The candidate's email
    */
    // @DataMember(Order=7)
    // @ApiMember(Description="The candidate\'s email", IsRequired=true)
    public email: string;

    /**
    * The candidate's telephone number
    */
    // @DataMember(Order=8)
    // @ApiMember(Description="The candidate\'s telephone number", IsRequired=true)
    public telephone: string;

    /**
    * The candidate's mobile number
    */
    // @DataMember(Order=9)
    // @ApiMember(Description="The candidate\'s mobile number", IsRequired=true)
    public mobile: string;

    /**
    * The candidate's street address
    */
    // @DataMember(Order=10)
    // @ApiMember(Description="The candidate\'s street address", IsRequired=true)
    public street: string;

    /**
    * The candidate's town/city
    */
    // @DataMember(Order=11)
    // @ApiMember(Description="The candidate\'s town/city", IsRequired=true)
    public city: string;

    /**
    * The candidate's state/province
    */
    // @DataMember(Order=12)
    // @ApiMember(Description="The candidate\'s state/province", IsRequired=true)
    public province: string;

    /**
    * The candidate's province code
    */
    // @DataMember(Order=13)
    // @ApiMember(Description="The candidate\'s province code", IsRequired=true)
    public provinceCode: string;

    /**
    * The candidate's country code of residence
    */
    // @DataMember(Order=14)
    // @ApiMember(Description="The candidate\'s country code of residence", IsRequired=true)
    public countryCode: string;

    /**
    * The candidate's postal code
    */
    // @DataMember(Order=15)
    // @ApiMember(Description="The candidate\'s postal code", IsRequired=true)
    public postalCode: string;

    /**
    * The candidate's current job title
    */
    // @DataMember(Order=16)
    // @ApiMember(Description="The candidate\'s current job title", IsRequired=true)
    public jobTitle: string;

    /**
    * The candidate's preferred communication language
    */
    // @DataMember(Order=17)
    // @ApiMember(Description="The candidate\'s preferred communication language", IsRequired=true)
    public contactLanguage: string;

    /**
    * The candidate's date of birth
    */
    // @DataMember(Order=18)
    // @ApiMember(Description="The candidate\'s date of birth")
    public dateOfBirth: string;

    /**
    * When set, this completed the staging process and the candidate is updated in the external system
    */
    // @DataMember(Order=19)
    // @ApiMember(Description="When set, this completed the staging process and the candidate is updated in the external system")
    public commitToExternal: boolean;

    /**
    * The candidate's preferred employment type
    */
    // @DataMember(Order=20)
    // @ApiMember(Description="The candidate\'s preferred employment type")
    public employmentType: string;

    public constructor(init?: Partial<UpdateStagedCandidateRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new UpdateStagedCandidateResponse(); }
    public getTypeName() { return 'UpdateStagedCandidateRequest'; }
}

/**
* Deletes a staged candidate
*/
// @Route("/candidate/staged/delete", "DELETE")
// @Api(Description="Deletes a staged candidate")
// @DataContract
export class DeleteStagedCandidateRequest implements IReturn<DeleteStagedCandidateResponse>, IDelete
{
    /**
    * The id of the staged candidate to delete
    */
    // @DataMember(Order=1)
    // @ApiMember(Description="The id of the staged candidate to delete", IsRequired=true)
    public candidateId: number;

    public constructor(init?: Partial<DeleteStagedCandidateRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteStagedCandidateResponse(); }
    public getTypeName() { return 'DeleteStagedCandidateRequest'; }
}

/**
* Returns a staged candidates normalised CV
*/
// @Route("/cv/normalised/{CandidateId}", "GET")
// @Api(Description="Returns a staged candidates normalised CV")
// @DataContract
export class GetStagedCandidateCvRequest implements IReturn<GetStagedCandidateCvResponse>, IGet
{
    /**
    * The staged candidate Id
    */
    // @DataMember(Order=1)
    // @ApiMember(Description="The staged candidate Id", IsRequired=true)
    public candidateId: number;

    public constructor(init?: Partial<GetStagedCandidateCvRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetStagedCandidateCvResponse(); }
    public getTypeName() { return 'GetStagedCandidateCvRequest'; }
}

/**
* Returns a list of staged candidates
*/
// @Route("/candidate/staged", "GET")
// @Api(Description="Returns a list of staged candidates")
// @DataContract
export class GetStagedCandidatesRequest implements IReturn<GetStagedCandidatesResponse>, IGet, IPagedRequest
{
    /**
    * Filter by user id
    */
    // @DataMember(Order=1)
    // @ApiMember(Description="Filter by user id")
    public userId: string;

    /**
    * the number of results to skip
    */
    // @DataMember(Order=2)
    // @ApiMember(Description="the number of results to skip")
    public skip: number;

    /**
    * the number of results to take
    */
    // @DataMember(Order=3)
    // @ApiMember(Description="the number of results to take")
    public take: number;

    /**
    * Filter by job advert id
    */
    // @DataMember(Order=4)
    // @ApiMember(Description="Filter by job advert id")
    public jobId: string;

    /**
    * Filter by a specific external id
    */
    // @DataMember(Order=5)
    // @ApiMember(Description="Filter by a specific external id")
    public externalId: string;

    public constructor(init?: Partial<GetStagedCandidatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetStagedCandidatesResponse(); }
    public getTypeName() { return 'GetStagedCandidatesRequest'; }
}

// @Route("/auth")
// @Route("/auth/{provider}")
// @DataContract
export class Authenticate implements IReturn<AuthenticateResponse>, IPost
{
    // @DataMember(Order=1)
    public provider: string;

    // @DataMember(Order=2)
    public state: string;

    // @DataMember(Order=3)
    public oauth_token: string;

    // @DataMember(Order=4)
    public oauth_verifier: string;

    // @DataMember(Order=5)
    public userName: string;

    // @DataMember(Order=6)
    public password: string;

    // @DataMember(Order=7)
    public rememberMe: boolean;

    // @DataMember(Order=8)
    public continue: string;

    // @DataMember(Order=9)
    public errorView: string;

    // @DataMember(Order=10)
    public nonce: string;

    // @DataMember(Order=11)
    public uri: string;

    // @DataMember(Order=12)
    public response: string;

    // @DataMember(Order=13)
    public qop: string;

    // @DataMember(Order=14)
    public nc: string;

    // @DataMember(Order=15)
    public cnonce: string;

    // @DataMember(Order=16)
    public useTokenCookie: boolean;

    // @DataMember(Order=17)
    public accessToken: string;

    // @DataMember(Order=18)
    public accessTokenSecret: string;

    // @DataMember(Order=19)
    public scope: string;

    // @DataMember(Order=20)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<Authenticate>) { (Object as any).assign(this, init); }
    public createResponse() { return new AuthenticateResponse(); }
    public getTypeName() { return 'Authenticate'; }
}

// @Route("/apikeys")
// @Route("/apikeys/{Environment}")
// @DataContract
export class GetApiKeys implements IReturn<GetApiKeysResponse>, IGet
{
    // @DataMember(Order=1)
    public environment: string;

    // @DataMember(Order=2)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<GetApiKeys>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetApiKeysResponse(); }
    public getTypeName() { return 'GetApiKeys'; }
}

// @Route("/apikeys/regenerate")
// @Route("/apikeys/regenerate/{Environment}")
// @DataContract
export class RegenerateApiKeys implements IReturn<RegenerateApiKeysResponse>, IPost
{
    // @DataMember(Order=1)
    public environment: string;

    // @DataMember(Order=2)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<RegenerateApiKeys>) { (Object as any).assign(this, init); }
    public createResponse() { return new RegenerateApiKeysResponse(); }
    public getTypeName() { return 'RegenerateApiKeys'; }
}

